"use client";

import { FC } from "react";

import {
  useSignUpFlowQueryParams,
} from "libs/state/src/lib/stores/signupFlow/hooks/useSignUpFlowQueryParams";

export const QueryParamHandler: FC = () => {
  useSignUpFlowQueryParams();

  return <></>;
};
